
import type Vue from 'vue'
import { computed, defineComponent, getCurrentInstance } from 'vue'
import { useInstance } from '../../../composables'
import { useExplainBrowse } from '../../../composables/explain/use-explain-browse'
import { useContextQuery } from '../../../composables/use-context-query/index'
import { ExplainSectionEnum } from '../../../enums/explain-section.enum'
import { FilterIdEnum } from '../../../enums/filter-id.enum'
import { UiTooltip } from '../../keen-ui'
import { EpbButton } from '../../shared'
import ExplainQueryMetrics from '../explain-query-metrics.component.vue'
import ExplainHeaderLayout from '../header-layout.component.vue'
import ExplainProductAnalysisSearchBox from './search-box.component.vue'

export default defineComponent({
  name: 'ExplainProductAnalysisHeader',
  components: {
    ExplainHeaderLayout,
    ExplainQueryMetrics,
    ExplainProductAnalysisSearchBox,
    EpbButton,
    UiTooltip,
  },
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    isCompareModeEnabled: {
      type: Boolean,
      required: true,
    },
    isInfoModeEnabled: {
      type: Boolean,
      required: true,
    },
  },
  setup() {
    const {
      proxy: { $epb },
    } = getCurrentInstance() as { proxy: Vue }

    const { query } = useContextQuery()
    const { isBrowseContext } = useExplainBrowse()

    const lastSevenDaysLabel = $epb.messages.filters.values[FilterIdEnum.DATE].lastSevenDays.label

    const { instanceConfig } = useInstance()

    const isInfoModeAvailable = computed(() => {
      return instanceConfig.value.allowShowProductInfo
    })

    return {
      baseClass: 'epb-explain-product-analysis-header',
      query,
      isBrowseContext,
      ExplainSectionEnum,
      lastSevenDaysLabel,
      isInfoModeAvailable,
    }
  },
})
